import {vue} from "../../../main";

export const providersServicesModule = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchAllProvidersServices(actions, {page, buids, amount, filter, sortcolumn, sortby}) {
            // console.log("fetchAllProviders", {page, amount, filter, sortcolumn, sortby});
            let params = {
                buids: (buids ||  actions.rootGetters['data/getSelectedBranchesIds']).join(","),
                page,
                amount,
                sortcolumn,
                sortby
            };
            return this.$api.baseApi().post('/providers/service/get/all', filter, {params})
                .then(response => {
                    return response.data?.objects;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['provider']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        fetchProviderRevenueStats(actions, filter) {
            let params = {
                buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),
            };
            return this.$api.baseApi().post(`/providers/service/get/stats/revenue`, filter, {params})
                .then(response => {
                    return response.data?.objects.ProviderStats;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['provider']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        fetchProviderServicesStats(actions, filter) {
            let params = {
                buids: actions.rootGetters['data/getSelectedBranchesIds'].join(","),
            };
            return this.$api.baseApi().post(`/providers/service/get/stats/services`, filter, {params})
                .then(response => {
                    return response.data?.objects.ProviderStats;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['provider']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        fetchProviderServicesBySystemId(actions, {systemName, id}) {
            return this.$api.baseApi().get(`/providers/service/get-by-system`, {params: {systemName: systemName, systemId: id}})
                .then(response => {
                    return response.data?.objects.services;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['provider']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        fetchServiceById(actions, id) {
            return this.$api.baseApi().get(`/providers/service/get/${id}`)
                .then(response => {
                    return response.data?.objects.service;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to retrieve', arguments: ['provider']},
                            message: (typeof error === "object" && error.message !== undefined ? error.message : error)
                        },
                        {root: true});
                    return error;
                });
        },
        insertService(actions, request) {
            return this.$api.baseApi().post(`/providers/service/add`, request)
                .then(response => {
                    actions.dispatch('notifications/success',
                        {
                            // title: vue.$t('update_success'),
                            title: 'Inserted provider',
                            message: 'Task updated successfully',
                        },
                        {root: true});
                    return response.data?.objects.service;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to insert', arguments: ['provider']},
                            message: (typeof error === "object" && error?.response?.data?.message != null ? error.response.data.message : error)
                        },
                        {root: true});
                    throw error?.response?.data;
                });
        },
        updateService(actions, {id, request}) {
            return this.$api.baseApi().post(`/providers/service/update/${id}`, request)
                .then(response => {
                    actions.dispatch('notifications/success',
                        {
                            title: 'Update provider',
                            message: 'Provider updated successfully',
                        },
                        {root: true});
                    return response.data?.objects.service;
                }).catch(error => {
                    actions.dispatch('notifications/error',
                        {
                            title: {text: '%s - failed to insert', arguments: ['provider']},
                            message: (typeof error === "object" && error?.response?.data?.message != null ? error.response.data.message : error)
                        },
                        {root: true});
                    throw error?.response?.data;
                });
        },
    }
}
